module.exports = __webpack_public_path__ + "media/budgeting_calculators/cost_proj_info-84e4f106.png";